import React from "react";
import { Badge } from "@/components/ui/badge";

interface ServiceItemProps {
  service: {
    name: string;
    price?: number | string | null;
    category: { name: string };
  };
}

export const ServiceItem: React.FC<ServiceItemProps> = ({ service }) => {
  return (
    <div className="flex flex-col gap-2 p-4 bg-zinc-100 rounded-xl border border-zinc-200 w-48 h-32 justify-between">
      <div className="flex justify-between items-start">
        <Badge
          variant="secondary"
          className="bg-zinc-800 text-white text-[10px] px-2 py-0"
        >
          {service.category.name}
        </Badge>
      </div>
      <div className="flex flex-col">
        <span className="text-sm font-medium line-clamp-2">{service.name}</span>
        <span className="text-xs text-zinc-500">
          {service.price ?? 0}€/pers.
        </span>
      </div>
    </div>
  );
};
